// This is a singleton service that provides a centralized way to access the map display context.

import { Itinerary } from 'models/itinerary';
import { DigitalMapPin } from 'models/digitalMap';
import { MapDisplayContextType, RestaurantPage } from './MapDisplayContext';
import { ItemSelection } from './RestaurantDetails/RestaurantDetails';

export interface MapServiceState {
  onGetDirections: ((origin: google.maps.LatLng, destinationPin: DigitalMapPin) => void) | null;
  newItinerary: Itinerary | null;
}

class MapDisplayContextService {
  private static instance: MapDisplayContextService;
  private mapDisplayContext: MapDisplayContextType | null = null;

  private constructor() {}

  static getInstance(): MapDisplayContextService {
    if (!MapDisplayContextService.instance) {
      MapDisplayContextService.instance = new MapDisplayContextService();
    }
    return MapDisplayContextService.instance;
  }

  setMapDisplayContext(context: MapDisplayContextType) {
    this.mapDisplayContext = context;
  }

  getMapDisplayContext(): MapDisplayContextType | null {
    return this.mapDisplayContext;
  }

  // Itinerary methods
  setNewItinerary(itinerary: Itinerary | null) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.setNewItinerary(itinerary);
    }
  }

  onGetDirections(origin: google.maps.LatLng, destinationPin: DigitalMapPin) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.onGetDirections(origin, destinationPin);
    }
  }

  setActiveRestaurantId(restaurantId: string | null) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.setActiveRestaurantId(restaurantId);
    }
  }

  setActiveItemSelection(itemSelection: ItemSelection) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.setActiveItemSelection(itemSelection);
    }
  }

  setActiveRestaurantPageStack(pageStack: RestaurantPage[]) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.setActiveRestaurantPageStack(pageStack);
    }
  }

  setSelectedFloor(floor: number) {
    if (this.mapDisplayContext) {
      this.mapDisplayContext.setSelectedFloor(floor);
    }
  }
}

export default MapDisplayContextService.getInstance();
